import http from '@/services/http';
import { error } from '@/utils/safetyLog';

export const getHeaderAndFooter = async (contentType: string, includeReference: string[], localLanguage: string) => {
  const endpoint = `/contentstack/${contentType}`;
  const payload = {
    queryObj: {},
    includeReference,
    language: localLanguage,
  };
  try {
    return await http({}).post(endpoint, payload);
  } catch (e) {
    error('getHeaderAndFooter error:', { httpEndpoint: http({}).defaults.baseURL + endpoint, payload: payload }, e);
    return { data: null }; 
  }
};
